// api should be here
import { http } from '@/utils/http';

const getNewsList = (params: any) => {
  return http.get(`/v1/news/topicList`, {
    params,
  });
};
const getNewsDetail = (classid: any, newsid: any) => {
  return http.get(`https://newsapi.cqcb.com/v1/detail?columnId=${classid}&newsId=${newsid}`);
};
export { getNewsList,getNewsDetail };
